import React, { useState, useRef } from "react"
import { useSelector, useDispatch } from 'react-redux'
import {
	CToast, CToastBody, CToastHeader, CToaster,
} from '@coreui/react';
import PropTypes from 'prop-types';
import { UFunc } from '../helpers/functions'

const MyToaster = props => {
    //const { toastData } 		= props;
	const uToastdataArr			= useSelector(state => state.listToast) || [];

	const uDispatch				= useDispatch();
	const activeTimers 			= useRef({});
	const toasterRef 			= useRef();

	const hdlCloseToastitem = React.useCallback((_TIMEID) => {
		const vNewArr = uToastdataArr.filter(vItems => vItems.id !== _TIMEID);
		uDispatch({type: "set", listToast: vNewArr});
	},[uToastdataArr,uDispatch])

	//React.useEffect(() => { console.log("(MyToaster - [] "); },[]);//*/
	/*React.useEffect(() => {
		console.log("(MyToaster - [uToastdataArr]) uToastdataArr = ",JSON.stringify(uToastdataArr));
	},[uToastdataArr]);//-*/
	React.useEffect(() => {
		//console.log("(MyToaster - [uToastdataArr,uDispatch]) uToastdataArr = ",JSON.stringify(uToastdataArr));
		//const currentToastIds 	= uToastdataArr.map(t => t.id);
		//const timersToKeep 		= {};

		uToastdataArr.forEach((vItems, vKeys) => {
			// Calculate the total time until this toast should disappear

			// Set the timeout to remove the toast from Redux
			const timerId = setTimeout(() => {
				clearTimeout(timerId);
				hdlCloseToastitem(vItems.id);
				
				// Clean up the timer reference after it fires
				//delete activeTimers.current[vItems.id];
			}, 3000);

			// Store the ID in our local reference object
			//timersToKeep[vItems.id] = timerId;
		});

		//activeTimers.current = timersToKeep;

    	return () => {// Clear all running timers when the component unmounts
    		//Object.values(activeTimers.current).forEach(id => clearTimeout(id));
    		//activeTimers.current = {}; 

    		// Clear Redux state on unmount, as you requested
    		//uDispatch({type: "set", listToast: undefined});
    	};
	},[uToastdataArr,uDispatch,hdlCloseToastitem]);
	
	//console.log("(MyToaster)  toaser = "+toaser.length);
	return (
		<>
		<CToaster placement="bottom-end" ref={toasterRef}>
		{uToastdataArr.map((vItems, vKeys)=>{
			let resultType = null;
			switch((vItems.type||"").toLowerCase()) {
				case "info":
					resultType = { class: "bg-info", title: "Informasi", }
					break;
				case "error":
					resultType = { class: "bg-danger", title: "Error", }
					break;
				case "sukses":
					resultType = { class: "bg-success", title: "Berhasil", }
					break;
				default:
					resultType = { class: "", title: "Informasi", }
			}

			return(
				<React.Fragment key={vKeys}>
				<CToast onClose={()=>hdlCloseToastitem(vItems.id)}
					animation={true} 
					delay={3000}
					autohide={true}
					visible={true}>
					<CToastHeader
						className={resultType.class+" text-white font-weight-bolder"} 
						closeButton>
						<b className="me-auto">{(resultType.title)}</b>
					</CToastHeader>

					<CToastBody>
					{UFunc.renderHTML(vItems.teksIsi)}
					</CToastBody>
				</CToast>
				</React.Fragment>
			)//>
		})}
		</CToaster>
		</>
	);
}
MyToaster.propTypes = {
	toastData: PropTypes.array,
}


export default MyToaster;
